import styled from 'styled-components'
import colors from '../../../configuration/colors'

const H5 = styled.div`
  color: ${props => props.dove ? colors.dove : colors.victoria};
  font-size: 16px;
  font-weight: 500;
`

export default H5



// WEBPACK FOOTER //
// ./src/components/typography/headers/H5.js